const Preconditions = require('./Preconditions.js'); 
const Message = require('./Message.js'); 

function Conversation(conversation_fragment_json, labels)
{
    this.data = [];
    this.upsert(conversation_fragment_json.messages);
    this.conversation_definition = conversation_fragment_json.conversation_definition;
    this.offset = conversation_fragment_json.offset;
    this.limit = conversation_fragment_json.limit;
    
}

Conversation.prototype.upsert = function(json)
{
    Preconditions.checkNotNull(json);

    if ( Preconditions.isArray(json) )
    {
        for ( let i = 0; i < json.length; i++ )
        {
            this.upsertOne(json[i]);
        }

        this.sort();

        return;
    }

    this.upsertOne(json);
    this.sort();
}

Conversation.prototype.sort = function(json)
{
    this.data.sort(function(a,b)
    {
        return b.getTime() - a.getTime();
    });
}

Conversation.prototype.upsertOne = function(json)
{
    // One Message...
    let message = new Message(json);


    // Delete any existing message
    for ( let i = 0; i < this.data.length; i++ )
    {
        if ( this.data[i].getId() === message.getId() )
        {
            this.data.splice(i,1);
            break;
        }
    }

    this.data.push(message);
}

Conversation.prototype.length = function()
{
    return this.data.length;
}

Conversation.prototype.get = function(index)
{
    Preconditions.checkNumber(index);
    return this.data[index];
}

Conversation.prototype.asArray = function()
{
    let ret = [];

    for ( let i = 0; i < this.length(); i++ )
    {
        ret.push(this.get(i));
    }

    return ret;
}

Conversation.prototype.getConversationId = function()
{
    return this.conversation_definition.conversation_id;
}

Conversation.prototype.getOrganizationAccountId = function()
{
    return this.conversation_definition.organization_id;
}

Conversation.prototype.getOrganizationId = function()
{
    return this.conversation_definition.organization_id;
}

Conversation.prototype.getConversationEndpoints = function()
{
    return this.conversation_definition.endpoints;
}

module.exports = Conversation;
